module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.showChangeRebateType()
      }
    }
  }, [_vm._v("批量设置返佣任务制")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleItemsTable",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.itemsList,
        "height": _vm.wheight - 240
      },
      on: {
        "selection-change": _vm.handleItemsSelectionChange,
        "filter-change": _vm.filterHandler
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "160"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleRebateConf(scope.row, 1)
              }
            }
          }, [_vm._v("分销参数")]), _vm._v(" "), _c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleRebateConf(scope.row, 2)
              }
            }
          }, [_vm._v("任务参数")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "返佣状态",
        "width": "160",
        "column-key": "rebate",
        "filters": [{
          text: '支持返佣',
          value: '1'
        }, {
          text: '不支持返佣',
          value: '0'
        }, {
          text: '等待审核',
          value: '2'
        }, {
          text: '拒绝加入',
          value: '3'
        }],
        "filter-multiple": false
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.allSelect && _vm.$store.getters.login_type != 'distributor') ? _c('div', [_c('el-switch', {
            attrs: {
              "active-color": "#13ce66",
              "disabled": ""
            },
            model: {
              value: (_vm.allSelect),
              callback: function($$v) {
                _vm.allSelect = $$v
              },
              expression: "allSelect"
            }
          })], 1) : _c('div', [(scope.row.rebate_audit === 2) ? _c('el-tag', {
            attrs: {
              "size": "mini"
            }
          }, [_vm._v("等待审核")]) : _vm._e(), _vm._v(" "), (scope.row.rebate_audit === 3) ? _c('el-tag', {
            attrs: {
              "size": "mini",
              "type": "warning"
            }
          }, [_vm._v("审核拒绝")]) : _vm._e(), _vm._v(" "), (scope.row.rebate_audit === 2 || scope.row.rebate_audit === 1 && _vm.$store.getters.login_type == 'distributor') ? _c('el-switch', {
            attrs: {
              "disabled": "",
              "active-color": "#13ce66"
            },
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.row)
              }
            },
            model: {
              value: (scope.row.rebate),
              callback: function($$v) {
                _vm.$set(scope.row, "rebate", $$v)
              },
              expression: "scope.row.rebate"
            }
          }) : _c('el-switch', {
            attrs: {
              "active-color": "#13ce66"
            },
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.row)
              }
            },
            model: {
              value: (scope.row.rebate),
              callback: function($$v) {
                _vm.$set(scope.row, "rebate", $$v)
              },
              expression: "scope.row.rebate"
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "商品图片",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-avatar', {
            attrs: {
              "shape": "square",
              "size": 60,
              "fit": "fit",
              "src": scope.row.pics[0]
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "标题",
        "prop": "item_name",
        "min-width": "250"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "销售价"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" " + _vm._s(scope.row.price / 100) + "元 ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "成本价"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" " + _vm._s(scope.row.cost_price / 100) + "元 ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store",
        "label": "库存",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "approve_status",
        "label": "状态",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status === 'onsale') ? _c('el-tag', {
            staticClass: "grid-content",
            attrs: {
              "type": "success"
            }
          }, [_vm._v(" 前台可销售 ")]) : (scope.row.approve_status === 'offline_sale') ? _c('el-tag', {
            staticClass: "grid-content",
            attrs: {
              "type": "info"
            }
          }, [_vm._v(" 可线下销售 ")]) : _c('el-tag', {
            staticClass: "grid-content",
            attrs: {
              "type": "danger"
            }
          }, [_vm._v(" 不可销售 ")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded content-center"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_task_sideBar,
      "title": "任务制配置",
      "width": "67"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_task_sideBar = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.current.item_name))]), _vm._v(" "), _c('span', [_c('el-alert', {
      staticClass: "alert-text",
      attrs: {
        "title": "比例计算",
        "description": "计算方式： 订单金额 × 百分比，其中订单金额为【支付金额-运费】，如果不填则不进行返佣",
        "type": "info",
        "close-text": " ",
        "show-icon": ""
      }
    })], 1)]), _vm._v(" "), _c('el-radio-group', {
      model: {
        value: (_vm.current.rebate_type),
        callback: function($$v) {
          _vm.$set(_vm.current, "rebate_type", $$v)
        },
        expression: "current.rebate_type"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "default"
      }
    }, [_vm._v("不支持任务制")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "total_money"
      }
    }, [_vm._v("任务制-按总金额")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "total_num"
      }
    }, [_vm._v("任务制-按总数量")])], 1)], 1), _vm._v(" "), (_vm.current.rebate_type != 'default') ? _c('el-card', {
      staticClass: "box-card"
    }, [_c('el-table', {
      attrs: {
        "data": _vm.rebateSpecItems
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "规格",
        "prop": "item_spec_desc",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.item_spec_desc) ? _c('span', [_vm._v(_vm._s(scope.row.item_spec_desc))]) : _c('span', [_vm._v("单规格")])]
        }
      }], null, false, 215542460)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "销售价",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.price / 100) + " ")]
        }
      }], null, false, 3624376491)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "成本价",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.cost_price / 100) + " ")]
        }
      }], null, false, 962853919)
    }), _vm._v(" "), _vm._l((3), function(item, key) {
      return _c('el-table-column', {
        key: key,
        attrs: {
          "label": "规则",
          "min-width": "120"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [_vm._v("\n              满足条件\n              "), _c('el-input', {
              attrs: {
                "size": "mini",
                "type": "number"
              },
              model: {
                value: (scope.row.rebate_conf.rebate_task[key].filter),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.rebate_task[key], "filter", $$v)
                },
                expression: "scope.row.rebate_conf.rebate_task[key].filter"
              }
            }), _vm._v("\n\n              返佣\n              "), (scope.row.rebate_conf.rebate_task_type == 'money') ? _c('el-input', {
              attrs: {
                "size": "mini",
                "type": "number",
                "suffix-icon": "iconfont icon-yen-sign"
              },
              model: {
                value: (scope.row.rebate_conf.rebate_task[key].money),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.rebate_task[key], "money", $$v)
                },
                expression: "scope.row.rebate_conf.rebate_task[key].money"
              }
            }) : _c('el-input', {
              attrs: {
                "size": "mini",
                "type": "number",
                "suffix-icon": "iconfont icon-percent"
              },
              model: {
                value: (scope.row.rebate_conf.rebate_task[key].ratio),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.rebate_task[key], "ratio", $$v)
                },
                expression: "scope.row.rebate_conf.rebate_task[key].ratio"
              }
            })]
          }
        }], null, true)
      })
    })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": _vm.saveRebateConf
      }
    }, [_vm._v("保存")])], 1)]
  })], 2), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": "分销参数配置",
      "width": "67"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.current.item_name))]), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("如果设置的返佣为固定金额，返佣金额就是设置的固定金额。否则按照 【返佣计算类型】计算返佣")]), _vm._v(" "), (_vm.popularizeSetting.popularize_ratio.type == 'profit') ? _c('span', [_c('el-alert', {
      staticClass: "alert-text",
      attrs: {
        "title": "返佣计算类型: 【按利润分佣】",
        "description": "计算方式：商品利润 ×  百分比，其中商品利润为【支付金额-运费-商品成本价】，如果不填则使用通用配置返佣",
        "type": "info",
        "close-text": " ",
        "show-icon": ""
      }
    })], 1) : _c('span', [_c('el-alert', {
      staticClass: "alert-text",
      attrs: {
        "title": "返佣计算类型: 【按订单金额分佣】",
        "description": "计算方式： 订单金额 × 百分比，其中订单金额为【支付金额-运费】，如果不填则使用通用配置返佣",
        "type": "info",
        "close-text": " ",
        "show-icon": ""
      }
    })], 1)]), _vm._v(" "), _c('el-table', {
      attrs: {
        "data": _vm.rebateSpecItems
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "规格",
        "prop": "item_spec_desc",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.item_spec_desc) ? _c('span', [_vm._v(_vm._s(scope.row.item_spec_desc))]) : _c('span', [_vm._v("单规格")])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "销售价",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.price / 100) + " ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "成本价",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.cost_price / 100) + " ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "类型",
        "width": "160"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "money",
              "inactive-value": "ratio",
              "active-text": "金额",
              "inactive-text": "比例"
            },
            model: {
              value: (scope.row.rebate_conf.type),
              callback: function($$v) {
                _vm.$set(scope.row.rebate_conf, "type", $$v)
              },
              expression: "scope.row.rebate_conf.type"
            }
          })]
        }
      }])
    }), _vm._v(" "), _vm._l((_vm.popularizeSetting.popularize_ratio.profit), function(item, key) {
      return _c('el-table-column', {
        key: key,
        attrs: {
          "label": item.name,
          "min-width": "110"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [(scope.row.rebate_conf.type == 'money') ? _c('el-input', {
              attrs: {
                "type": "number",
                "size": "mini",
                "suffix-icon": "iconfont icon-yen-sign"
              },
              model: {
                value: (scope.row.rebate_conf.value[key]),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.value, key, $$v)
                },
                expression: "scope.row.rebate_conf.value[key]"
              }
            }) : _c('el-input', {
              attrs: {
                "size": "mini",
                "type": "number",
                "suffix-icon": "iconfont icon-percent"
              },
              model: {
                value: (scope.row.rebate_conf.value[key]),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.value, key, $$v)
                },
                expression: "scope.row.rebate_conf.value[key]"
              }
            })]
          }
        }], null, true)
      })
    })], 2)], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": _vm.saveRebateConf
      }
    }, [_vm._v("保存")])], 1)]
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改商品返佣任务制支持",
      "visible": _vm.changeRebateTypeVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.changeRebateTypeVisible = $event
      }
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.changeRebateType),
      callback: function($$v) {
        _vm.changeRebateType = $$v
      },
      expression: "changeRebateType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "default"
    }
  }, [_vm._v("不支持任务制")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "total_money"
    }
  }, [_vm._v("任务制-按总金额")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "total_num"
    }
  }, [_vm._v("任务制-按总数量")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.changeRebateTypeVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBatchChange
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bd9b6456", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd9b6456"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/popularize/goods.vue
// module id = 2922
// module chunks = 0